"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsList = exports.CardProduct = exports.Grid = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
const molecules_1 = require("../../molecules");
exports.Grid = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(351px, 1fr));
  grid-template-rows: 1fr 1fr 1fr;
  row-gap: 50px;
  margin-bottom: 20px;
  width: 100%;
  align-items: stretch;

  a {
    color: black;
  }
`;
exports.CardProduct = (0, styled_components_1.default)(molecules_1.CardProduct) `
  width: 25vw;
  height: 330px;
`;
exports.ProductsList = styled_components_1.default.div `
  position: relative;
`;
